// Función para obtener el valor del parámetro de la URL
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// Obtener el valor del parámetro "iclid" de la URL
var iclid = getParameterByName('iclid');

// Función para establecer una cookie
function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/; domain=' + window.location.hostname;
  console.log(
    'Cookie establecida: ' + name + '=' + (value || '') + expires + '; path=/; domain=' + window.location.hostname
  );
}

// Añadir evento para establecer la cookie cuando el documento esté listo
document.addEventListener('DOMContentLoaded', function () {
  var iclid = getParameterByName('iclid');
  if (iclid) {
    setCookie('iclid', iclid, 30); // La cookie expira después de 30 días
  }
});
